import moment from "moment-timezone";
import { ShipmentStatus } from "@api/graphql/generated/generated-types";

export interface DriverPayRange {
  minDate: string;
  maxDate: string;
  shipmentStatuses: ShipmentStatus[];
  shouldFetch: boolean;
}

const PAID_SHIPMENT_STATUSES: ShipmentStatus[] = [
  ShipmentStatus.Completed,
  ShipmentStatus.Routed,
  ShipmentStatus.InTransit,
];

export function getTodayRangeForDailyDriverEarnings(
  isEnabled: boolean
): DriverPayRange {
  if (!isEnabled) {
    return {
      minDate: "1970-01-01",
      maxDate: "1970-01-01",
      shipmentStatuses: [],
      shouldFetch: false,
    };
  }
  const today: string = moment().format("YYYY-MM-DD");
  return {
    minDate: today,
    maxDate: today,
    shipmentStatuses: PAID_SHIPMENT_STATUSES,
    shouldFetch: true,
  };
}

export function getThisWeekRangeForDriverPay(
  isEnabled: boolean
): DriverPayRange {
  if (!isEnabled) {
    return {
      minDate: "1970-01-01",
      maxDate: "1970-01-01",
      shipmentStatuses: [],
      shouldFetch: false,
    };
  }
  return {
    minDate: moment().startOf("isoWeek").format("YYYY-MM-DD"),
    maxDate: moment().endOf("isoWeek").format("YYYY-MM-DD"),
    shipmentStatuses: PAID_SHIPMENT_STATUSES,
    shouldFetch: true,
  };
}
